import { some } from "lodash";
import { ProductVariants } from "./product-variants";

class ProductBundle extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }

  bindEvents() {
    const colourOptions = this.querySelectorAll(".swatch-color__icon");
    colourOptions?.forEach((option) => {
      option.addEventListener("click", () => {
        const qty = this.dataset.bundleQuantity || "1";
        this.fetchProduct(event, this, qty);
      });
    });

    const productVariantInputs = this.querySelectorAll("product-variants input");
    const productVariants = new ProductVariants();
    const reference = this;

    productVariantInputs.forEach((input) => {
      const variantId = input.getAttribute("data-id") as string;

      input.addEventListener("change", () => {
        productVariants.onVariantSelect(variantId, reference);
      });
    });
  }

  fetchProduct(event: any, ref: any, qty: string) {
    event.preventDefault();
    ref.classList.add("loading");
    const target = event.currentTarget;
    const productHandle = target.getAttribute("data-product-handle");

    fetch(`${productHandle}`)
      .then((response) => response.text())
      .then((data) => {
        const productSwatchGroup = ref.getSectionInnerHTML(
          data,
          ".product__bundle-product-placeholder product-bundle"
        ) as string;
        ref.outerHTML = productSwatchGroup.replace(
          'data-product-bundle-url',
          `data-bundle-quantity="${qty}" data-product-bundle-url`
        ).replace(
          '<h6>',
          qty !== '1' ? `<h6>${qty}x ` : '<h6>'
        );
        ref.bindEvents();
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  getSectionInnerHTML(html: string, selector: string) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector)?.outerHTML;
  }
}

customElements.define("product-bundle", ProductBundle);

